// Design-system JS tokens: the single source of truth for status/stage colours
// and small formatting helpers that the CSS can't express (dynamic inline
// styles). Keep this in lockstep with tokens.css.

// Status → pill styling. Colours are deliberately distinct so New/Pending/
// Approved/Info Requested/Rejected/Closed are never confusable. Info Requested
// (orange) is kept clearly apart from Rejected (red).
export const STATUS_META = {
  new: { label: "New", fg: "#475467", bg: "#F2F4F7", border: "#E2E6ED" },
  draft: { label: "Draft", fg: "#475467", bg: "#F2F4F7", border: "#E2E6ED" },
  pending: { label: "Waiting for approval", fg: "#1D4ED8", bg: "#E8EFFE", border: "#E8EFFE" },
  approved: { label: "Approved", fg: "#0E7A57", bg: "#E6F5F0", border: "#E6F5F0" },
  info_requested: { label: "Info requested", fg: "#B45309", bg: "#FEF3E2", border: "#FEF3E2" },
  rejected: { label: "Rejected", fg: "#B42318", bg: "#FEECEA", border: "#FEECEA" },
  closed: { label: "Closed", fg: "#475467", bg: "#F2F4F7", border: "#E2E6ED" },
  sent_to_accounting: { label: "Sent to accounting", fg: "#1D4ED8", bg: "#E8EFFE", border: "#E8EFFE" },
  paid: { label: "Paid", fg: "#0E7A57", bg: "#E6F5F0", border: "#E6F5F0" },
  unpaid: { label: "Unpaid", fg: "#B45309", bg: "#FEF3E2", border: "#FEF3E2" },
}

export const statusMeta = (code) =>
  STATUS_META[code] || {
    label: code || "—",
    fg: "#475569",
    bg: "#f1f5f9",
    border: "#cbd5e1",
  }

// The four P2P stages a live order moves through, in order. Short labels keep
// the compact list-cell stepper legible.
export const STAGE_ORDER = ["order", "purchase", "goods_receipt", "payment"]
export const STAGE_META = {
  order: { label: "Order", short: "Order" },
  purchase: { label: "Purchase", short: "Purchase" },
  goods_receipt: { label: "Goods Receipt", short: "GRN" },
  payment: { label: "Payment", short: "Payment" },
}
export const stageIndex = (code) => {
  const i = STAGE_ORDER.indexOf(code)
  return i === -1 ? 0 : i
}

// Budget-health colour ramp for the Remaining column / progress bar.
// >20% left → healthy, 10–20% → watch, <10% → critical.
export const budgetHealth = (remaining, total) => {
  if (!total || total <= 0) return { key: "na", color: "#94a3b8" }
  const ratio = remaining / total
  if (ratio < 0.1) return { key: "critical", color: "#b91c1c" }
  if (ratio < 0.2) return { key: "low", color: "#b45309" }
  return { key: "ok", color: "#0d9488" }
}

export const clampPct = (n) => Math.max(0, Math.min(100, n))
